import { KOSAccountBindItem, RedbookAccount } from '@/interfaces/redbook';
import request from '../utils/request';
import {
  EmpowerAccount,
  ChannelMaterialPageInfo,
  ChannelMaterialType,
  ChannelSimpleInfo,
  OpenAuthUrlResponse,
  ChannelAccountListRequest,
  ChannelMaterialSaveRequest,
  ChannelMaterialUpdateRequest,
  ChannelMaterialDeleteRequest,
} from '@/interfaces/channel';
import { PaginationData, PaginationParams } from '@/interfaces/request';

export const getLastOpenStatus = (source?: 'redbook' | 'douyin') => {
  return request<EmpowerAccount>({
    url: '/v1/channel/account/last-open-success',
    method: 'GET',
    params: { source },
  });
};

export const getOpenUrl = (reqPage?: string) => {
  return request<{ url: string }>({
    url: `/v1/channel/auth/redbook/open-url`,
    method: 'GET',
    params: { reqPage },
  });
};

// 新增接口 - 获取抖音开放认证url
export const getDouyinOpenUrl = (reqPage?: string) => {
  return request<OpenAuthUrlResponse>({
    url: '/v1/channel/auth/douyin/open-url',
    method: 'GET',
    params: { reqPage },
  });
};

export const authRedbookOpen = (preCode: string) => {
  return request({
    url: '/v1/channel/auth/redbook/open',
    method: 'POST',
    data: { preCode },
  });
};

export const getChannelMaterialList = (data: {
  page: number;
  pageSize: number;
  materialType?: ChannelMaterialType;
  materialTitle?: string;
  isPull?: boolean;
  materialIds?: string[];
  source?: string;
  subSourceId?: string;
}) => {
  return request<ChannelMaterialPageInfo>({
    url: '/v1/channel/material/page',
    method: 'POST',
    data,
  });
};

export const getChannelSimpleList = (source?: string, relationId?: string) => {
  return request<ChannelSimpleInfo[]>({
    url: '/v1/channel/account/simple-list',
    method: 'POST',
    data: { source, relationId },
  });
};

export const deleteRedbookAccount = (relationId: string) => {
  return request({
    url: '/v1/channel/account/redbook/del',
    method: 'DELETE',
    params: { relationId },
  });
};

// 新增接口 - 渠道账号列表（通用）
export const getChannelAccountListNew = (data: ChannelAccountListRequest) => {
  return request<RedbookAccount[]>({
    url: '/v1/channel/account/list',
    method: 'POST',
    data,
  });
};

// 新增接口 - 执行抖音开放认证
export const authDouyinOpen = (preCode: string) => {
  return request<boolean>({
    url: '/v1/channel/auth/douyin/open',
    method: 'POST',
    data: { preCode },
  });
};

// 保存物料
export const saveChannelMaterial = (data: ChannelMaterialSaveRequest) => {
  return request<boolean>({
    url: '/v1/channel/material/save',
    method: 'POST',
    data,
  });
};

// 更新物料
export const updateChannelMaterial = (data: ChannelMaterialUpdateRequest) => {
  return request<boolean>({
    url: '/v1/channel/material/update',
    method: 'PUT',
    data,
  });
};

// 删除物料
export const deleteChannelMaterial = (data: ChannelMaterialDeleteRequest) => {
  return request<boolean>({
    url: '/v1/channel/material/del',
    method: 'DELETE',
    data,
  });
};

export const updateReceptionType = (data: {
  receptionType: string;
  relationId: string;
  source: string;
}) => {
  return request({
    url: '/v1/channel/account/update-reception-type',
    method: 'POST',
    data,
  });
};

// 渠道账号锁定
export const lockRedbookAccount = (relationIds: string[]) => {
  return request({
    url: '/v1/channel/account/lock',
    method: 'POST',
    data: { relationIds },
  });
};

// 渠道账号解锁
export const unlockRedbookAccount = (relationIds: string[]) => {
  return request({
    url: '/v1/channel/account/unlock',
    method: 'POST',
    data: { relationIds },
  });
};

// 三方 kos 分页查询
export const getThirdPartyKosList = (
  data: PaginationParams<{
    parentRelationId: string;
  }>,
) => {
  return request<PaginationData<KOSAccountBindItem>>({
    url: '/v1/channel/account/redbook/third-kos-page',
    method: 'POST',
    data: { parentRelationId: data.parentRelationId, ...data.pageReq },
  });
};

// kos 解绑
export const unbindThirdPartyKos = (parentRelationId: string, relationId: string) => {
  return request<boolean>({
    url: '/v1/channel/account/redbook/kos-unbind',
    method: 'POST',
    data: { parentRelationId, relationId },
  });
};

// 小红书聚光预约码生成
export const redbookAdPreAuth = () => {
  return request<{ code: string }>({
    url: '/v1/channel/auth/redbook/ad-preauth',
    method: 'POST',
  });
};

// kos 绑定
export const bindThirdPartyKos = (kosList: KOSAccountBindItem[], parentRelationId: string) => {
  const kosListForBind = kosList.map((kos) =>
    Object.fromEntries(Object.entries(kos).filter(([key]) => key !== 'hasBind')),
  );

  return request<boolean>({
    url: '/v1/channel/account/redbook/kos-bind',
    method: 'POST',
    data: { kosList: kosListForBind, parentRelationId },
  });
};
